<div journey-login>
    <div login-section>
        <img src="assets/images/kpmg-logo-login.svg"><br><br>
        <span text>You are Logged out. To Login Again, INTERNAL users <a (click)="auth.socialLogin('datapower')">click here</a></span>
        <amplify-authenticator [hideSignUp]="true">
            <amplify-sign-in header-text="" slot="sign-in"></amplify-sign-in>
        </amplify-authenticator>
    </div>
</div>